<template>
	<v-dialog persistent width="auto" v-model="dialog" v-if="selectedMedicationEvent">
		<v-card
			style="min-height: 60vh; max-height: 80vh; width: 33vw; min-width: 400px"
			class="overflow-auto d-flex flex-column">
			<v-card-title class="card-header text-left fixed-card-title2">
				<v-row no-gutters>
					<v-col class="align-center d-flex" cols="10">
						<v-toolbar-title>{{ $t('medication-event-details-header') }}</v-toolbar-title>
					</v-col>
					<v-spacer></v-spacer>
					<v-icon @click="$emit('closeDialog')" class="white-icon">mdi-close</v-icon>
				</v-row>
			</v-card-title>
			<v-card-text class="pa-4 flex-grow-1 d-flex flex-column">
				<div class="flex-grow-1">
					<v-row dense class="ma-0">
						<v-col cols="12" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('brand-name') }}:</div>
							<div class="text-body-1">{{ selectedMedicationEvent.medicationName }}</div>
						</v-col>
						<v-col cols="12" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('generic-name') }}:</div>
							<div class="text-body-1">{{ selectedMedicationEvent.genericName }}</div>
						</v-col>
						<v-col cols="12" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('manufacturer-name') }}:</div>
							<div class="text-body-1">{{ selectedMedicationEvent.manufacturerName }}</div>
						</v-col>
						<v-col cols="3" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('frequency') }}:</div>
							<div class="text-body-1">{{ selectedMedicationEvent.frequency }}</div>
						</v-col>
						<v-col cols="3" class="text-center">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('duration') }}:</div>
							<div class="text-body-1">{{ selectedMedicationEvent.durationDays }} {{ $t('days') }}</div>
						</v-col>
						<v-col cols="3" class="text-center">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('route') }}:</div>
							<div class="text-body-1">{{ selectedMedicationEvent.route }}</div>
						</v-col>
						<v-col cols="3" class="text-right">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('course-status') }}:</div>
							<div class="text-body-1">
								{{ $t(selectedMedicationEvent.isMedicationHasEnded ? 'finished' : 'on-going') }}
							</div>
						</v-col>
						<v-col cols="12" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('dosage') }}:</div>
							<div class="text-body-1">{{ selectedMedicationEvent.dosage }}</div>
						</v-col>
						<v-col cols="12" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('additional-info') }}:</div>
							<div class="text-body-1" style="white-space: pre-wrap">{{ selectedMedicationEvent.additionalinfo }}</div>
						</v-col>
					</v-row>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-row dense class="ma-0">
					<v-col cols="8" class="text-left">
						<span class="text-subtitle-1 font-weight-bold">{{ $t('timestamp') }}:</span>
						<span class="text-body-1">{{ formatTimestamp(selectedMedicationEvent.eventDate, 'datetime_med') }}</span>
					</v-col>
					<v-col cols="4" class="text-right">
						<span class="text-subtitle-1 font-weight-bold">{{ $t('By') }}:</span>
						<span class="text-body-1">{{ selectedMedicationEvent.performedBy }}</span>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { formatTimestamp } from '@/utils/utilities';
export default {
	name: 'CCMMedicationEventViewDialog',

	props: ['dialog', 'selectedMedicationEvent'],

	methods: {
		formatTimestamp,
	},
};
</script>
